// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-invoices-search .bg-light.p-3.rounded-3.mb-3 {
    background: #f5f6f8 !important;
    border: 1px solid #d9dde3;
    border-radius: 12px !important;
}

.cost-invoices-search .row.p-3.mb-2.rounded.shadow-sm.mx-0 {
    border-radius: 12px !important;
    box-shadow: none !important;
}

.cost-invoice-card__header {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}

.cost-invoice-card__number {
    font-size: 1.65rem;
    font-weight: 700;
    line-height: 1.15;
}

.cost-invoice-card__supplier {
    margin-top: 0.6rem;
    font-size: 1.1rem;
    font-weight: 600;
}

.cost-invoice-card__meta {
    margin-top: 0.2rem;
    color: #6c757d;
    font-size: 0.9rem;
}

.cost-invoice-card__status-wrap {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 0.35rem;
}

.cost-invoice-card__body {
    display: flex;
    justify-content: space-between;
    gap: 1.2rem;
    margin-top: 0.95rem;
}

.cost-invoice-card__dates {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 1rem;
    flex: 1;
    border-right: 1px solid #e3e6eb;
    padding-right: 1rem;
}

.cost-invoice-card__label {
    color: #6c757d;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.cost-invoice-card__value {
    margin-top: 0.2rem;
    font-weight: 600;
}

.cost-invoice-card__amounts {
    min-width: 240px;
    text-align: right;
}

.cost-invoice-card__gross {
    font-size: 1.9rem;
    line-height: 1.05;
    font-weight: 700;
}
.cost-invoice-card__value--paid {
    color: #198754;
}
.cost-invoice-card__amount-detail {
    margin-top: 0.2rem;
    color: #495057;
}

.cost-invoice-card__bottom {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.75rem;
    margin-top: 0.9rem;
    padding-top: 0.75rem;
    border-top: 1px solid #eceff3;
}

.cost-invoice-card__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.cost-invoice-card__footer {
    display: flex;
    align-items: baseline;
    gap: 0.45rem;
    margin-left: auto;
    color: #6c757d;
    font-size: 0.86rem;
    white-space: nowrap;
}

.cost-invoice-card__ksef {
    font-size: 0.82rem;
    color: #495057;
    word-break: break-all;
}

@media (max-width: 991px) {
    .cost-invoice-card__body {
        flex-direction: column;
    }

    .cost-invoice-card__dates {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        border-right: 0;
        border-bottom: 1px solid #e3e6eb;
        padding-right: 0;
        padding-bottom: 0.75rem;
    }

    .cost-invoice-card__amounts {
        text-align: left;
        min-width: 0;
    }

    .cost-invoice-card__gross {
        font-size: 1.5rem;
    }
}

@media (max-width: 767px) {
    .cost-invoice-card__header {
        flex-direction: column;
    }

    .cost-invoice-card__status-wrap {
        min-width: 0;
        align-items: flex-start;
    }

    .cost-invoice-card__bottom {
        flex-direction: column;
        align-items: flex-start;
    }

    .cost-invoice-card__footer {
        margin-left: 0;
        white-space: normal;
    }

    .cost-invoice-card__dates {
        grid-template-columns: 1fr;
        gap: 0.7rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Erp/CostInvoicesList/CostInvoicesSearch.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gDAAgD;QAChD,eAAe;QACf,gCAAgC;QAChC,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,WAAW;IACf;AACJ","sourcesContent":[".cost-invoices-search .bg-light.p-3.rounded-3.mb-3 {\n    background: #f5f6f8 !important;\n    border: 1px solid #d9dde3;\n    border-radius: 12px !important;\n}\n\n.cost-invoices-search .row.p-3.mb-2.rounded.shadow-sm.mx-0 {\n    border-radius: 12px !important;\n    box-shadow: none !important;\n}\n\n.cost-invoice-card__header {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.cost-invoice-card__number {\n    font-size: 1.65rem;\n    font-weight: 700;\n    line-height: 1.15;\n}\n\n.cost-invoice-card__supplier {\n    margin-top: 0.6rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n\n.cost-invoice-card__meta {\n    margin-top: 0.2rem;\n    color: #6c757d;\n    font-size: 0.9rem;\n}\n\n.cost-invoice-card__status-wrap {\n    min-width: 180px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-end;\n    gap: 0.35rem;\n}\n\n.cost-invoice-card__body {\n    display: flex;\n    justify-content: space-between;\n    gap: 1.2rem;\n    margin-top: 0.95rem;\n}\n\n.cost-invoice-card__dates {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n    gap: 1rem;\n    flex: 1;\n    border-right: 1px solid #e3e6eb;\n    padding-right: 1rem;\n}\n\n.cost-invoice-card__label {\n    color: #6c757d;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.cost-invoice-card__value {\n    margin-top: 0.2rem;\n    font-weight: 600;\n}\n\n.cost-invoice-card__amounts {\n    min-width: 240px;\n    text-align: right;\n}\n\n.cost-invoice-card__gross {\n    font-size: 1.9rem;\n    line-height: 1.05;\n    font-weight: 700;\n}\n.cost-invoice-card__value--paid {\n    color: #198754;\n}\n.cost-invoice-card__amount-detail {\n    margin-top: 0.2rem;\n    color: #495057;\n}\n\n.cost-invoice-card__bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 0.75rem;\n    margin-top: 0.9rem;\n    padding-top: 0.75rem;\n    border-top: 1px solid #eceff3;\n}\n\n.cost-invoice-card__tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n}\n\n.cost-invoice-card__footer {\n    display: flex;\n    align-items: baseline;\n    gap: 0.45rem;\n    margin-left: auto;\n    color: #6c757d;\n    font-size: 0.86rem;\n    white-space: nowrap;\n}\n\n.cost-invoice-card__ksef {\n    font-size: 0.82rem;\n    color: #495057;\n    word-break: break-all;\n}\n\n@media (max-width: 991px) {\n    .cost-invoice-card__body {\n        flex-direction: column;\n    }\n\n    .cost-invoice-card__dates {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        border-right: 0;\n        border-bottom: 1px solid #e3e6eb;\n        padding-right: 0;\n        padding-bottom: 0.75rem;\n    }\n\n    .cost-invoice-card__amounts {\n        text-align: left;\n        min-width: 0;\n    }\n\n    .cost-invoice-card__gross {\n        font-size: 1.5rem;\n    }\n}\n\n@media (max-width: 767px) {\n    .cost-invoice-card__header {\n        flex-direction: column;\n    }\n\n    .cost-invoice-card__status-wrap {\n        min-width: 0;\n        align-items: flex-start;\n    }\n\n    .cost-invoice-card__bottom {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .cost-invoice-card__footer {\n        margin-left: 0;\n        white-space: normal;\n    }\n\n    .cost-invoice-card__dates {\n        grid-template-columns: 1fr;\n        gap: 0.7rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
